import {useEffect, useCallback, useRef, MutableRefObject} from 'react';
import {useConsole} from './consoleStore';
import {useLocation} from "react-router-dom";

const useResizableConsole = (containerRef) => {
    const location = useLocation();
    const maskRef: MutableRefObject<HTMLDivElement | null> = useRef<HTMLDivElement>(null);
    const {setIsResizing, setConsoleHeight, isResizing, setIsMaximized} = useConsole();

    const startResizing = useCallback((mouseDownEvent) => {
        if(!maskRef.current) {
            maskRef.current = document.createElement("div");
            maskRef.current.style.position = "fixed";
            maskRef.current.style.top = "0px";
            maskRef.current.style.bottom = "0px";
            maskRef.current.style.left = "0px";
            maskRef.current.style.right = "0px";
            maskRef.current.style.zIndex = "9999999999999";
        }
        document.body.appendChild(maskRef.current);
        mouseDownEvent.preventDefault();
        setIsResizing(true);
    }, [setIsResizing]);

    const stopResizing = useCallback(() => {
        setIsResizing(false);
        const {defaultView, parentWindow} = event.target.ownerDocument;
        const targetWindow = defaultView || parentWindow;
        const newHeight = targetWindow !== window ? window.innerHeight - targetWindow.innerHeight - 54 : window.innerHeight - event.clientY
        const containerHeight = containerRef.current.parentElement.clientHeight;
        const maxHeight = containerHeight * 0.98; // 98% of the container height auto maximize
        if (newHeight > maxHeight) {
            setIsMaximized(true);
            setConsoleHeight('100%');
        }
        if(maskRef.current) {
            maskRef.current.remove();
            maskRef.current = null;
        }
    }, [setIsResizing]);

    const resizeConsole = useCallback((event) => {
        if (containerRef.current) {
            const {defaultView, parentWindow} = event.target.ownerDocument;
            const targetWindow = defaultView || parentWindow;
            const commonHeight = window.innerHeight - event.clientY;
            const newHeight = targetWindow !== window ? commonHeight - 70 : commonHeight + 5;
            setConsoleHeight(`${newHeight}px`);
        }
        event.preventDefault();
    }, [setConsoleHeight, stopResizing, containerRef]);

    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', resizeConsole);
            window.addEventListener('mouseup', stopResizing);
        } else {
            window.removeEventListener('mousemove', resizeConsole);
            window.removeEventListener('mouseup', stopResizing);
        }

        return () => {
            window.removeEventListener('mousemove', resizeConsole);
            window.removeEventListener('mouseup', stopResizing);
        };
    }, [isResizing, resizeConsole, stopResizing, location]);
    return {startResizing};
};

export default useResizableConsole;
